import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["websiteType", "to", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx as s } from "react/jsx-runtime";
import { useContext as m } from "react";
import { WebsiteContext as b } from "../../context/website.js";
import { getBaseWebsiteUrl as f } from "../../helpers/getBaseWebsiteUrl.js";
function w(n) {
  var e = n.websiteType,
    t = n.to,
    r = n.children,
    i = _objectWithoutProperties(n, _excluded),
    _m = m(b),
    o = _m.Link,
    p = _m.websiteType;
  return e === p && o != null ? /* @__PURE__ */s(o, _objectSpread(_objectSpread({
    to: t
  }, i), {}, {
    children: r
  })) : /* @__PURE__ */s("a", _objectSpread(_objectSpread({
    href: "".concat(f(e)).concat(t)
  }, i), {}, {
    children: r
  }));
}
export { w as WebsiteLink };